export default {
        findMaxIndex(item){
            var maxIndex=0;
            item ? item.forEach(x =>{
              if (x.serialsInfo) {
                x.serialsInfo.forEach(serialsList =>{
                  maxIndex=Math.max(maxIndex,0,serialsList.index)
                  serialsList.index
                })  
              }
            }):0
            return ++maxIndex
          },
    // }
  };